var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"alert",attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24px","viewBox":"0 0 24 24","width":"24px"}},[_c('path',{staticClass:"a",attrs:{"d":"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }